const isClient = (typeof __CLIENT__ !== 'undefined') ? __CLIENT__ : true;

const GoogleAnalyticsPlugin = (isClient)
    ? require('./GoogleAnalyticsPlugin').default
    : {}
;

export default GoogleAnalyticsPlugin;
